import { Component } from '@angular/core';

@Component({
  selector: 'cva-standalone-invalid-agent',
  standalone: true,
  imports: [],
  templateUrl: './invalid-agent.component.html',
  styleUrl: './invalid-agent.component.scss'
})
export class InvalidAgentComponent {

}
